import types from './types';
import service from '../../../service/index';
import ui from '@/ui';
import { get } from '@/request/utils';

let { GET_VIP_DETAIL } = types;

export default {
  getVipDetail( { commit } ) {
    return ui.withLoading(service.getVipDetail)().then(r => {
      let vipDetail = get(r, "res.bd.data", {});
      commit(GET_VIP_DETAIL, vipDetail);
    });
  }
}


// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/home/store/actions.js